import { PencilLineIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { IconButton } from '@/shared/ui';

type Props = {
  isActive: boolean;
  /** Войти в режим нельзя: включён показ без анонимизации, а правится анонимизированный текст */
  isUnavailable: boolean;
  onToggle: () => void;
};

/**
 * Вход в режим редактирования расшифровки и выход из него.
 */
export const TranscriptEditModeButton: FC<Props> = ({ isActive, isUnavailable, onToggle }) => {
  const { t } = useTranslation(['dialogs']);

  const getLabel = () => {
    if (isActive) return t('dialogs:transcriptEdit.exitMode');
    if (isUnavailable) return t('dialogs:transcriptEdit.unavailableNonAnonymized');
    return t('dialogs:transcriptEdit.enterMode');
  };

  const isBlocked = !isActive && isUnavailable;

  // Недоступность выражена `aria-disabled`, а не `disabled`: неактивная кнопка не получает наведения,
  // и подсказка с причиной недоступности у неё не показалась бы
  return (
    <IconButton
      size="sm"
      variant={isActive ? 'default' : 'outline'}
      icon={<PencilLineIcon />}
      label={getLabel()}
      aria-pressed={isActive}
      aria-disabled={isBlocked}
      className={cn(isBlocked && 'opacity-50')}
      onClick={isBlocked ? undefined : onToggle}
    />
  );
};
